/* unplugin-vue-components disabled */import { render } from "./home_product.vue?vue&type=template&id=a83d9df2&scoped=true"
import script from "./home_product.vue?vue&type=script&lang=js"
export * from "./home_product.vue?vue&type=script&lang=js"

import "./home_product.vue?vue&type=style&index=0&id=a83d9df2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a83d9df2"]])

export default __exports__